export default "__VITE_ASSET__sZNLwpro__"